import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export type Breadcrumb = {
  label: string;
  to?: string;
};

type PageHeaderProps = {
  title: string;
  /** Компактный бейдж рядом с заголовком (например статус записи). */
  badge?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  breadcrumbs?: readonly Breadcrumb[];
  /** Уменьшенные отступы для плотных страниц вроде карточки расшифровки. */
  compact?: boolean;
};

export function PageHeader({
  title,
  badge,
  description,
  actions,
  breadcrumbs,
  compact = false,
}: PageHeaderProps) {
  return (
    <div className={`page-header${compact ? ' page-header--compact' : ''}`}>
      <div className="page-header__text">
        {breadcrumbs !== undefined && breadcrumbs.length > 0 ? (
          <nav className="breadcrumbs" aria-label="Навигационная цепочка">
            {breadcrumbs.map((crumb, index) => (
              <span key={`${crumb.label}-${index}`}>
                {index > 0 ? (
                  <span className="breadcrumbs__separator" aria-hidden="true">
                    {' / '}
                  </span>
                ) : null}
                {crumb.to !== undefined ? (
                  <Link to={crumb.to}>{crumb.label}</Link>
                ) : (
                  <span>{crumb.label}</span>
                )}
              </span>
            ))}
          </nav>
        ) : null}
        <div className="page-header__title-row">
          <h1>{title}</h1>
          {badge !== undefined ? <div className="page-header__badge">{badge}</div> : null}
        </div>
        {description !== undefined ? (
          <div className="page-header__description">{description}</div>
        ) : null}
      </div>
      {actions !== undefined ? <div className="page-header__actions">{actions}</div> : null}
    </div>
  );
}
